import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalOverlay } from "@chakra-ui/modal";
import { useCallback, useContext, useEffect, useState } from "react";
import { MdHighlightOff } from "react-icons/md";
import { getAllOrganizationsSecond } from "api/graphQL_organizations";
import { getClientsSecond, getClientTreasuryTotal } from "api/graphQL_clients";
import { Select as AntSelect } from "antd";
import DivLoader from "components/divloader/DivLoader";
import { FiUploadCloud, FiXCircle } from "react-icons/fi";
import toast from "react-hot-toast";
import { useDropzone } from "react-dropzone";
import { ClientContext } from "ClientProvider";
import { createBatchPayout } from "api/graphQL_crypto";
import Batch from "../../../../../assets/csv/Batch.csv";
import BloxBatch from "../../../../../assets/csv/BloxCryptoBatch.csv";
import CapaBatch from "../../../../../assets/csv/CapaCryptoBacth.csv";
import OrionXBatch from "../../../../../assets/csv/OrionXCryptoBatch.csv";
import Papa from "papaparse";
// import { getAllGatewaysByClient, getClientTreasuryTotal as _ct } from "api/graphQL_clients";
import { getAllGatewaysByClient , getGatewayBalance} from "api/graphQL_gateways";
import { getCurrencySymbol, currencyCodes } from "utils/currencyList";
import axios from "axios";

/* ── Types ── */
interface DisplayData {
  gateway: any; currency: any;
  total_amount: { totalAmount: any; totalPercentageFee: any; totalFixedFee: any; totalFees: any } | null;
  gateway_id: any; client_id: any; gateway_details: any; gateway_balance: any; client_treasury: any;
}
interface iCreateBatchForm { org_id: string; client_id: string; approval_type: string; batch_file: any; gateway: any; }
export type AllGatewayObj = { name: string; id: string; };
export type SourceCurrencyObj = { name: string; id: string; };

/* ── Currency lists per gateway ── */
const BLOX_CURRENCIES: SourceCurrencyObj[] = [
  {id:"KYD",name:"Cayman Islands Dollar"},{id:"USD",name:"US Dollar"},{id:"EUR",name:"Euro"},{id:"GBP",name:"Pound Sterling"},
  {id:"JPY",name:"Yen"},{id:"CAD",name:"Canadian Dollar"},{id:"AUD",name:"Australian Dollar"},{id:"CHF",name:"Swiss Franc"},
  {id:"CNY",name:"Yuan Renminbi"},{id:"HKD",name:"Hong Kong Dollar"},{id:"SGD",name:"Singapore Dollar"},{id:"NOK",name:"Norwegian Krone"},
  {id:"SEK",name:"Swedish Krona"},{id:"DKK",name:"Danish Krone"},{id:"NZD",name:"New Zealand Dollar"},{id:"MXN",name:"Mexican Peso"},
  {id:"BRL",name:"Brazilian Real"},{id:"INR",name:"Indian Rupee"},{id:"KRW",name:"Won"},{id:"TRY",name:"Turkish Lira"},
  {id:"ZAR",name:"Rand"},{id:"SAR",name:"Saudi Riyal"},{id:"AED",name:"UAE Dirham"},{id:"PLN",name:"Zloty"},
  {id:"NGN",name:"Naira"},{id:"COP",name:"Colombian Peso"},{id:"CLP",name:"Chilean Peso"},{id:"PHP",name:"Philippine Peso"},
  {id:"MYR",name:"Malaysian Ringgit"},{id:"THB",name:"Baht"},{id:"IDR",name:"Rupiah"},{id:"ILS",name:"New Israeli Sheqel"},
  {id:"HUF",name:"Forint"},{id:"CZK",name:"Czech Koruna"},{id:"RON",name:"Romanian Leu"},{id:"RUB",name:"Russian Ruble"},
  {id:"UAH",name:"Hryvnia"},{id:"EGP",name:"Egyptian Pound"},{id:"KES",name:"Kenyan Shilling"},{id:"GHS",name:"Ghana Cedi"},
  {id:"PKR",name:"Pakistan Rupee"},{id:"BDT",name:"Taka"},{id:"VND",name:"Dong"},{id:"QAR",name:"Qatari Rial"},
  {id:"KWD",name:"Kuwaiti Dinar"},{id:"BHD",name:"Bahraini Dinar"},{id:"OMR",name:"Rial Omani"},{id:"MAD",name:"Moroccan Dirham"},
  {id:"TND",name:"Tunisian Dinar"},{id:"ARS",name:"Argentine Peso"},{id:"UYU",name:"Peso Uruguayo"},{id:"PEN",name:"Sol"},
  {id:"GTQ",name:"Quetzal"},{id:"DOP",name:"Dominican Peso"},{id:"CRC",name:"Costa Rican Colon"},{id:"HNL",name:"Lempira"},
];

const ORIONX_CURRENCIES: SourceCurrencyObj[] = [
  {id:"DOT",name:"Polkadot (DOT)"},{id:"USDC",name:"USD Coin (USDC)"},{id:"XAUT",name:"Tether Gold (XAUT)"},
  {id:"DAI",name:"Dai (DAI)"},{id:"EURT",name:"Euro Tether (EURT)"},{id:"BTC",name:"Bitcoin (BTC)"},
  {id:"DASH",name:"Dash (DASH)"},{id:"TRX",name:"TRON (TRX)"},{id:"CLP",name:"Chilean Pesos (CLP)"},
  {id:"BCH",name:"Bitcoin Cash (BCH)"},{id:"ADA",name:"Cardano (ADA)"},{id:"USDT",name:"Tether (USDT)"},
  {id:"XLM",name:"Stellar Lumens (XLM)"},{id:"AVAX",name:"Avalanche (AVAX)"},{id:"EOS",name:"EOS.IO (EOS)"},
  {id:"LTC",name:"Litecoin (LTC)"},{id:"ETH",name:"Ethereum (ETH)"},{id:"BNB",name:"Binance Coin (BNB)"},
  {id:"XRP",name:"Ripple (XRP)"},
];

/* ── Dropzone ── */
const FileDropzone = ({ label, onFileSelect, onRemoveFile, sampleBatchFile, resetKey }: {
  label: string; onFileSelect: (file: string | null) => void;
  onRemoveFile: any; sampleBatchFile: any; resetKey?: any;
}) => {
  const [fileName, setFileName] = useState("");
  const onDrop = useCallback((acceptedFiles: File[]) => {
    const file = acceptedFiles[0];
    if (file) {
      const allowed = ["text/csv","application/vnd.ms-excel"];
      if (allowed.includes(file.type)) {
        setFileName(file.name);
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => onFileSelect(reader.result as string);
      } else { toast.error("Only CSV files are allowed."); setFileName(""); onFileSelect(""); }
    }
  }, [onFileSelect]);
  useEffect(() => { if (resetKey) { onRemoveFile(true); setFileName(""); onFileSelect(""); } }, [resetKey]);
  const removeFile = () => { onRemoveFile(true); setFileName(""); onFileSelect(""); };
  const { getRootProps, getInputProps } = useDropzone({ onDrop, disabled: !sampleBatchFile });
  return (
    <div {...getRootProps()} className={`cpabf-dropzone${sampleBatchFile ? " cpabf-dropzone--active" : " cpabf-dropzone--disabled"}`}>
      <input {...getInputProps()} />
      {fileName ? (
        <div className="cpabf-dropzone-file">
          <FiUploadCloud size={16} style={{ color:"#16a34a" }} />
          <span className="cpabf-dropzone-filename">{fileName}</span>
          <button className="cpabf-dropzone-remove" onClick={(e) => { e.stopPropagation(); removeFile(); }}>
            <FiXCircle size={14} />
          </button>
        </div>
      ) : (
        <div className="cpabf-dropzone-placeholder">
          <FiUploadCloud size={28} style={{ color: sampleBatchFile ? "#7c3aed" : "#cbd5e1", marginBottom:"8px" }} />
          <p className="cpabf-dropzone-label">{label}</p>
          {!sampleBatchFile && <p className="cpabf-dropzone-hint">Select a gateway first</p>}
        </div>
      )}
    </div>
  );
};

/* ── Main component ── */
const AddBatchFile = ({ fetchPayouts }: { fetchPayouts: () => void }) => {
  const rootForm: iCreateBatchForm = { org_id:"", client_id:"", approval_type:"", batch_file:"", gateway:"" };
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isCloseModal, setIsCloseModal] = useState(false);
  const [page] = useState(1); const [pageSize] = useState(500); const [searchTexts] = useState("");
  const [organizations, setOrganizations] = useState<any[]>([]);
  const [allOrg, setAllOrg] = useState<any[]>([]);
  const [clients, setClients] = useState<any[]>([]);
  const [formValues, setFormValues] = useState<iCreateBatchForm>(rootForm);
  const [formValuesErr, setFormValuesErr] = useState<iCreateBatchForm>(rootForm);
  const [isLoading, setIsLoading] = useState(false);
  const [batchFile, setBatchFile] = useState<string | null>(null);
  const [removeFile, setRemoveFile] = useState(false);
  const { singleRoleData } = useContext(ClientContext);
  const [allGateways, setAllGateways] = useState<AllGatewayObj[]>([]);
  const [allSourceCurrency, setAllSourceCurrency] = useState<SourceCurrencyObj[]>([]);
  const [addDisabled, isAddDisabled] = useState(true);
  const [sourceCurrency, setSourceCurrency] = useState("");
  const [selectedGateway, setSelectedGateway] = useState("");
  const [displayData, setDisplayData] = useState<DisplayData | null>(null);
  const [isBalanceLoading, setIsBalanceLoading] = useState(false);
  const [lowBalanceError, setLowBalanceError] = useState("");
  const [sampleBatchFile, setSampleBatchFile] = useState<string | null>(null);
  const [smapleBatchName, setSampleBatchName] = useState("");
  const [resetKey, setResetKey] = useState(0);

  const sampleBatch: Record<string, any> = { Blox: BloxBatch, Capa: CapaBatch, Orionx: OrionXBatch };

  const fetchSourceCurrency = (gateway: any) => {
    setSelectedGateway(gateway ?? "");
    if (gateway === "Blox") setAllSourceCurrency(BLOX_CURRENCIES);
    else if (gateway === "Orionx") setAllSourceCurrency(ORIONX_CURRENCIES);
    else setAllSourceCurrency([]);
  };

  const fetchClients = (org_id: any) => {
    if (!org_id) { setClients([]); return; }
    const name = allOrg.find(o => o.id === org_id)?.name || '';
    getClientsSecond({ page, per_page: pageSize, searchTexts: name })
      .then((data) => setClients(data?.[0]?.map((e: any) => ({ name: e.name, id: e.client_id }))));
  };

  const fetchOrganizations = () => {
    getAllOrganizationsSecond(page, pageSize, searchTexts).then((data) => {
      const mapped = data?.[0]?.map((e: any) => ({ name: e.name, id: e.id }));
      setOrganizations(mapped); setAllOrg(mapped);
    });
  };

  const fetchGateways = (client_id: any) => {
    getAllGatewaysByClient(client_id).then((data) => {
      const filtered = (data ?? []).filter((gw: any) =>
        gw?.payment_method?.filterPaymentMethod?.some((m: any) => m.name === "crypto payout" && m.is_Active === true)
      );
      setAllGateways(filtered.map((item: any) => ({ ...item, id: item.gateway_id })));
    }).catch(console.error);
  };

  const handleClose = () => {
    setFormValues(rootForm); setFormValuesErr(rootForm); setBatchFile("");
    setIsCloseModal(true); setClients([]); setAllGateways([]);
    setAllSourceCurrency([]); setSourceCurrency(""); setDisplayData(null);
    isAddDisabled(true); setSampleBatchFile(null); setSampleBatchName("");
    setTimeout(() => { setIsCloseModal(false); onClose(); }, 300);
  };

  useEffect(() => {
    if (typeof batchFile === "string" && batchFile.trim() !== "") {
      setRemoveFile(false);
      setFormValues((p: any) => ({ ...p, batch_file: batchFile }));
      setFormValuesErr((p: any) => ({ ...p, batch_file: "" }));
      fetchBalance(batchFile);
    }
  }, [batchFile]);

  useEffect(() => {
    if (removeFile) { setFormValues((p: any) => ({ ...p, batch_file: "" })); setDisplayData(null); }
  }, [removeFile]);

  function validateData() {
    let v: any = {};
    if (!formValues?.org_id) v.org_id = "The field is required";
    if (!formValues?.client_id) v.client_id = "The field is required";
    if (!formValues?.gateway) v.gateway = "The field is required";
    if (!formValues?.approval_type) v.approval_type = "The field is required";
    if (!formValues?.batch_file) v.batch_file = "The field is required";
    if (Object.keys(v).length > 0) { setFormValuesErr(v); return false; }
    return true;
  }

  const REQUIRED_HEADERS = ["currency","chain","address","amount","customer_id","external_customer_no","tax_id"];
  const validateCSV = (csvDataUri: string) => {
    const csvText = atob(csvDataUri.replace(/^data:text\/csv;base64,/, ''));
    const parsed = Papa.parse<Record<string, string>>(csvText, { header: true, skipEmptyLines: true });
    if (parsed.errors.length > 0) { toast.error("CSV parsing failed, please download sample CSV"); return false; }
    const actualHeaders = Object.keys(parsed.data[0] || {});
    const missing = REQUIRED_HEADERS.filter(h => !actualHeaders.includes(h));
    if (missing.length > 0) { toast.error(`Missing headers: ${missing.map(h => h.replace(/_/g,' ')).join(", ")}`); return false; }
    const nonEmpty = parsed.data.filter(row => Object.values(row).some(v => v && String(v).trim() !== ""));
    for (let i = 0; i < nonEmpty.length; i++) {
      const row = nonEmpty[i];
      for (const header of REQUIRED_HEADERS) {
        if (!row[header] || String(row[header]).trim() === "") {
          toast.error(`Row ${i + 2}: "${header.replace(/_/g,' ')}" is missing. Please download sample CSV.`);
          return false;
        }
      }
    }
    return true;
  };

  async function handleSubmit(e: any) {
    e.preventDefault();
    if (!validateData()) return;
    if (!validateCSV(formValues.batch_file)) return;
    setIsLoading(true);
    createBatchPayout({
      client_id: formValues.client_id, organization_id: formValues.org_id,
      type: formValues.approval_type.replace("_",'-'), file: formValues.batch_file,
      gateway: formValues.gateway, currency: sourceCurrency,
      total_fees: (displayData?.total_amount?.totalFees ?? "0"),
    }).then((data: any) => {
      if (data.message === 'There are no any crypto gateway assigned to client') toast.error(data.message);
      else { toast.success(data.message); handleClose(); fetchPayouts(); }
      setIsLoading(false);
    }).catch(() => setIsLoading(false));
  }

  const convertAmount = async (amount: any, from: any, to: any) => {
    return axios.get(`https://api.fastforex.io/convert?api_key=629bf7299e-e7215fb94a-s85scd&from=${from}&to=${to}&amount=${amount}`)
      .then(r => r.data.result[to]).catch(() => null);
  };

  const readCSV = async (csvDataUri: string, margin_fee: any) => {
    if (!validateCSV(csvDataUri)) return false;
    const csvText = atob(csvDataUri.replace(/^data:text\/csv;base64,/, ''));
    const { data, errors } = Papa.parse<Record<string, string>>(csvText, { header: true, skipEmptyLines: true });
    if (errors.length > 0) { toast.error("CSV parsing failed"); return false; }
    const pf = parseFloat(margin_fee?.percentageFee || "0"), ff = parseFloat(margin_fee?.fixedFee || "0");
    let totalAmount = 0, totalPercentageFee = 0, totalFixedFee = 0;
    for (const row of data) {
      if (row.amount && row.currency) {
        const converted = await convertAmount(row.amount, row.currency, sourceCurrency);
        const amt = isNaN(parseFloat(converted)) ? 0 : parseFloat(converted);
        totalAmount += amt; totalPercentageFee += amt * (pf / 100); totalFixedFee += ff;
      }
    }
    return { totalAmount, totalPercentageFee, totalFixedFee, totalFees: totalPercentageFee + totalFixedFee };
  };

  const fetchMarginFee = async (client_id: any, gateway_id: any) => {
    return getAllGatewaysByClient(client_id).then((data) => {
      if (!data || !Array.isArray(data)) return null;
      const gw = data.find((g: any) => g.gateway_id === gateway_id);
      if (!gw) return null;
      const cf = gw?.reserved_pricing?.crypto_fees;
      if (!cf || cf.currency_code !== sourceCurrency) { if (cf) toast.error("Crypto fees not defined for " + sourceCurrency); return null; }
      return { percentageFee: cf.percentage_fee, fixedFee: cf.fixed_fee, currency_code: cf.currency_code, authInfo: gw?.auth_info };
    }).catch(() => null);
  };

  const fetchClientTreasury = async (client_id: any) => {
    return getClientTreasuryTotal(client_id, sourceCurrency).then((data) => data[0].total_treasury).catch(() => null);
  };

  const fetchBalance = async (batchFile: any) => {
    setIsBalanceLoading(true); isAddDisabled(true);
    const gd = await fetchMarginFee(formValues.client_id, formValues.gateway);
    if (gd) {
      const total_amount = await readCSV(batchFile, gd);
      if (total_amount) {
        const ct = await fetchClientTreasury(formValues.client_id);
        setDisplayData({ gateway: selectedGateway, currency: sourceCurrency, total_amount: typeof total_amount === "object" ? total_amount : null, gateway_id: formValues.gateway, client_id: formValues.client_id, gateway_details: gd, gateway_balance: null, client_treasury: ct });
        if (parseFloat(ct) > total_amount.totalFees) { isAddDisabled(false); setLowBalanceError(""); }
        else { isAddDisabled(true); setLowBalanceError("Insufficient funds. Please contact your representative to refill your account."); }
      } else { setDisplayData(null); }
    } else { setDisplayData(null); }
    setIsBalanceLoading(false);
  };

  const handleFieldChange = (field: string, value: any) => {
    const gw = allGateways.find((g: any) => g.id === value);
    const gw_name = gw ? gw.name : "";
    const gatewayDisplayName =
      singleRoleData?.[0]?.fiat?.value?.show_fiat_payout_gateway_name
        ? gw?.name || ""
        : gw?.id || "";
    const batch = sampleBatch[gw_name as keyof typeof sampleBatch] || null;
    setSampleBatchFile(batch || null); setSampleBatchName(batch ? `${gatewayDisplayName} Batch File` : "");
    setFormValues((p: any) => ({ ...p, [field]: value, batch_file: "" }));
    setFormValuesErr((p: any) => ({ ...p, [field]: "" }));
    setDisplayData(null); setResetKey(prev => prev + 1);
  };

  return (
    <>
      {singleRoleData?.[0]?.crypto?.value?.add_batch_file && (
        <button className="cpabf-trigger-btn" onClick={() => { fetchOrganizations(); onOpen(); }}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
          Crypto Batch Payout
        </button>
      )}

      <Modal isOpen={isOpen} onClose={() => {}}>
        <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)" />
        <div className={`cpabf-panel${isOpen && !isCloseModal ? " cpabf-panel--open" : " cpabf-panel--close"}`}>
          <div className="cpabf-glow" />

          <div className="cpabf-header">
            <div className="cpabf-header-brand">
              <div className="cpabf-header-logo">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
              </div>
              <div>
                <h2 className="cpabf-title">Crypto Batch Payout</h2>
                <p className="cpabf-sub">Upload and configure a crypto batch payout file</p>
              </div>
            </div>
            <button className="cpabf-close" onClick={handleClose}><MdHighlightOff size={22} /></button>
          </div>

          <div className="cpabf-body">
            {/* Organization */}
            <div className="cpabf-field-group">
              <label className="cpabf-label">Organization <span className="cpabf-req">*</span></label>
              <AntSelect showSearch allowClear placeholder="Select Organization"
                filterOption={(i, o) => (o?.label ?? '').toLowerCase().includes(i.toLowerCase())}
                className="cpabf-ant-select" style={{ width:"100%" }}
                options={organizations.map((m: any) => ({ ...m, label: m.name, value: m.id }))}
                value={formValues?.org_id || undefined}
                onChange={(e: any) => {
                  setFormValues((p: any) => ({ ...p, org_id: e, client_id:"", gateway:"" }));
                  setFormValuesErr((p: any) => ({ ...p, org_id:"" }));
                  setAllGateways([]); fetchClients(e);
                }}
                notFoundContent="Organization not found"
              />
              {formValuesErr?.org_id && <p className="cpabf-err">{formValuesErr.org_id}</p>}
            </div>

            {/* Client */}
            <div className="cpabf-field-group">
              <label className="cpabf-label">Client <span className="cpabf-req">*</span></label>
              <AntSelect showSearch allowClear placeholder="Select Client"
                filterOption={(i, o) => (o?.label ?? '').toLowerCase().includes(i.toLowerCase())}
                className="cpabf-ant-select" style={{ width:"100%" }}
                options={clients.map((m: any) => ({ label: m.name, value: m.id }))}
                value={formValues?.client_id || undefined}
                onChange={(e: any) => {
                  setFormValues((p: any) => ({ ...p, client_id: e, gateway:"" }));
                  setFormValuesErr((p: any) => ({ ...p, client_id:"" }));
                  setAllGateways([]);
                  if (formValues.batch_file) { setSampleBatchFile(null); setSampleBatchName(""); setFormValues((p: any) => ({ ...p, batch_file:"" })); setDisplayData(null); setResetKey(k => k + 1); }
                  fetchGateways(e);
                }}
                notFoundContent="Client not found"
              />
              {formValuesErr?.client_id && <p className="cpabf-err">{formValuesErr.client_id}</p>}
            </div>

            {/* Gateway */}
            <div className="cpabf-field-group">
              <label className="cpabf-label">Gateway <span className="cpabf-req">*</span></label>
              <AntSelect showSearch allowClear placeholder="Select Gateway"
                filterOption={(i, o) => (o?.label ?? '').toLowerCase().includes(i.toLowerCase())}
                className="cpabf-ant-select" style={{ width:"100%" }}
                options={allGateways.map((m: any) => ({ ...m, label: singleRoleData?.[0]?.crypto?.value?.show_crypto_payout_gateway_name ? m.name : m.id, value: m.id }))}
                value={formValues?.gateway || undefined}
                onChange={(e: any) => handleFieldChange("gateway", e)}
                onSelect={(_: any, opt: any) => fetchSourceCurrency(opt.label)}
                notFoundContent="Gateway not found"
              />
              {formValuesErr?.gateway && <p className="cpabf-err">{formValuesErr.gateway}</p>}
            </div>

            {/* Settlement Currency */}
            <div className="cpabf-field-group">
              <label className="cpabf-label">Settlement Currency <span className="cpabf-req">*</span></label>
              <AntSelect showSearch allowClear placeholder="Select Currency"
                filterOption={(i, o) => (o?.label ?? '').toLowerCase().includes(i.toLowerCase())}
                className="cpabf-ant-select" style={{ width:"100%" }}
                options={allSourceCurrency.length > 0
                  ? allSourceCurrency.map((c) => ({ value: c.id, label: `${c.id}: ${c.name}` }))
                  : currencyCodes.map((c) => { const d = getCurrencySymbol(c); return { value: c, label: `${c}: ${d.title?.toUpperCase()}` }; })
                }
                value={sourceCurrency || undefined}
                onChange={(e: any) => {
                  setSourceCurrency(e);
                  if (formValues.batch_file) { setFormValues((p: any) => ({ ...p, batch_file:"" })); setDisplayData(null); setResetKey(k => k + 1); }
                }}
                notFoundContent="Currency not found"
              />
            </div>

            {/* Approval type */}
            <div className="cpabf-field-group">
              <label className="cpabf-label">Approval Type <span className="cpabf-req">*</span></label>
              <div className="cpabf-radio-row">
                {[{ val:"auto_approve", label:"Auto Approve" }, { val:"require_approve", label:"Require Approve" }].map((opt) => (
                  <label key={opt.val} className={`cpabf-radio-card${formValues.approval_type === opt.val ? " cpabf-radio-card--active" : ""}`}>
                    <input type="radio" name="approval_type" value={opt.val} checked={formValues.approval_type === opt.val}
                      onChange={(e) => { setFormValues((p: any) => ({ ...p, approval_type: e.target.value })); setFormValuesErr((p: any) => ({ ...p, approval_type:"" })); }} />
                    <span>{opt.label}</span>
                  </label>
                ))}
              </div>
              {formValuesErr?.approval_type && <p className="cpabf-err">{formValuesErr.approval_type}</p>}
            </div>

            {/* CSV Upload */}
            <div className="cpabf-field-group">
              <div className="cpabf-csv-label-row">
                <label className="cpabf-label">CSV File <span className="cpabf-req">*</span></label>
                {sampleBatchFile && (
                  <a href={sampleBatchFile} download={`${smapleBatchName}.csv`} className="cpabf-download-link">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                    Download {smapleBatchName}
                  </a>
                )}
              </div>
              <FileDropzone label="Upload Batch CSV File" onFileSelect={setBatchFile} onRemoveFile={setRemoveFile} sampleBatchFile={sampleBatchFile} resetKey={resetKey} />
              {formValuesErr?.batch_file && <p className="cpabf-err">{formValuesErr.batch_file}</p>}
            </div>

            {/* Balance preview */}
            {isBalanceLoading ? (
              <div className="cpabf-loading"><div className="cpabf-spinner" /><p className="cpabf-loading-txt">Calculating batch amounts…</p></div>
            ) : displayData ? (
              <div className="cpabf-summary">
                <div className="cpabf-summary-main">
                  <div>
                    <p className="cpabf-summary-key">Total Batch Amount</p>
                    <p className="cpabf-summary-val">{displayData?.total_amount?.totalAmount?.toFixed(2)} <span className="cpabf-summary-currency">{sourceCurrency}</span></p>
                  </div>
                  <div className="cpabf-summary-fees">
                    <div className="cpabf-fee-row"><span>Percentage Fee</span><span className="cpabf-fee-val">{displayData?.total_amount?.totalPercentageFee?.toFixed(2)} {sourceCurrency}</span></div>
                    <div className="cpabf-fee-row"><span>Fixed Fee</span><span className="cpabf-fee-val">{displayData?.total_amount?.totalFixedFee?.toFixed(2)} {sourceCurrency}</span></div>
                  </div>
                </div>
                <div className="cpabf-summary-grid">
                  <div className="cpabf-summary-card cpabf-summary-card--green">
                    <p className="cpabf-summary-card-label">Total Fees</p>
                    <p className="cpabf-summary-card-val">{displayData?.total_amount?.totalFees?.toFixed(2)} <span>{displayData?.currency}</span></p>
                  </div>
                  <div className="cpabf-summary-card cpabf-summary-card--purple">
                    <p className="cpabf-summary-card-label">Client Treasury</p>
                    <p className="cpabf-summary-card-val">{parseFloat(displayData?.client_treasury).toFixed(2)} <span>{sourceCurrency}</span></p>
                  </div>
                </div>
                {lowBalanceError && (
                  <div className="cpabf-error-banner">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
                    <span>{lowBalanceError}</span>
                  </div>
                )}
              </div>
            ) : null}
          </div>

          <div className="cpabf-footer">
            <div className="cpabf-footer-note">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              All fields are required to proceed
            </div>
            <div className="cpabf-footer-btns">
              <button className="cpabf-btn-cancel" onClick={handleClose}>Cancel</button>
              <button className="cpabf-btn-submit" onClick={handleSubmit} disabled={isLoading || addDisabled}>
                {isLoading ? <span className="cpabf-btn-spinner" /> : (
                  <><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>Add Batch</>
                )}
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        .cpabf-trigger-btn { display:inline-flex; align-items:center; gap:7px; font-family:'Plus Jakarta Sans',sans-serif; font-size:13px; font-weight:700; color:#fff; padding:7px 18px; border-radius:10px; border:none; background:linear-gradient(135deg,#6d28d9,#7c3aed); cursor:pointer; box-shadow:0 3px 12px rgba(124,58,237,.28); transition:all .15s; white-space:nowrap; }
        .cpabf-trigger-btn:hover { transform:translateY(-1px); box-shadow:0 6px 20px rgba(124,58,237,.36); }

        .cpabf-panel { font-family:'Plus Jakarta Sans',sans-serif; position:fixed; top:0; right:0; bottom:0; width:100%; max-width:560px; background:#fff; z-index:1004; display:flex; flex-direction:column; box-shadow:-12px 0 60px rgba(15,23,42,.18); transition:transform .35s cubic-bezier(0.16,1,0.3,1); overflow:hidden; }
        .cpabf-panel--open  { transform:translateX(0); }
        .cpabf-panel--close { transform:translateX(100%); }

        .cpabf-glow { height:3px; flex-shrink:0; background:linear-gradient(90deg,#3b0764,#7c3aed,#a855f7,#7c3aed,#3b0764); background-size:200% 100%; animation:cpabfGlow 3s linear infinite; }
        @keyframes cpabfGlow { 0%{background-position:0%} 100%{background-position:200%} }

        .cpabf-header { padding:15px 26px; background:linear-gradient(135deg,#3b0764 0%,#6d28d9 60%,#7c3aed 100%); display:flex; align-items:center; justify-content:space-between; flex-shrink:0; }
        .cpabf-header-brand { display:flex; align-items:center; gap:13px; }
        .cpabf-header-logo { width:42px; height:42px; border-radius:12px; background:rgba(255,255,255,.15); border:1.5px solid rgba(255,255,255,.25); display:flex; align-items:center; justify-content:center; flex-shrink:0; }
        .cpabf-title { font-size:16px; font-weight:800; color:#fff; letter-spacing:-.3px; margin-bottom:2px; line-height:1; }
        .cpabf-sub { font-size:12px; color:rgba(255,255,255,.55); font-weight:500; }
        .cpabf-close { background:none; border:none; cursor:pointer; color:rgba(255,255,255,.65); display:flex; align-items:center; transition:color .15s; }
        .cpabf-close:hover { color:#fff; }

        .cpabf-body { flex:1; padding:20px 26px; overflow-y:auto; display:flex; flex-direction:column; gap:16px; }
        .cpabf-body::-webkit-scrollbar { width:4px; }
        .cpabf-body::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:4px; }

        .cpabf-field-group { display:flex; flex-direction:column; gap:6px; }
        .cpabf-label { font-size:13px; font-weight:700; color:#0f172a; }
        .cpabf-req { color:#dc2626; }
        .cpabf-err { font-size:12px; color:#dc2626; font-weight:500; }
        .cpabf-ant-select .ant-select-selector { height:44px !important; border:1.5px solid #e2e8f0 !important; border-radius:10px !important; background:#f8fafc !important; font-family:'Plus Jakarta Sans',sans-serif !important; }
        .cpabf-ant-select .ant-select-selection-search-input { height:42px !important; }
        .cpabf-ant-select .ant-select-selection-placeholder { line-height:42px !important; color:#cbd5e1 !important; font-size:13px !important; }
        .cpabf-ant-select .ant-select-selection-item { line-height:42px !important; font-size:13px !important; font-weight:600 !important; }

        .cpabf-radio-row { display:flex; gap:10px; flex-wrap:wrap; }
        .cpabf-radio-card { display:flex; align-items:center; gap:8px; padding:11px 16px; background:#f8fafc; border:1.5px solid #e2e8f0; border-radius:10px; cursor:pointer; font-size:13px; font-weight:600; color:#475569; transition:all .15s; flex:1; min-width:130px; }
        .cpabf-radio-card input[type="radio"] { accent-color:#7c3aed; width:15px; height:15px; flex-shrink:0; }
        .cpabf-radio-card--active { background:#faf5ff; border-color:#ddd6fe; color:#6d28d9; }

        .cpabf-csv-label-row { display:flex; align-items:center; justify-content:space-between; gap:8px; }
        .cpabf-download-link { display:inline-flex; align-items:center; gap:5px; font-size:12px; font-weight:600; color:#7c3aed; text-decoration:none; transition:color .15s; }
        .cpabf-download-link:hover { color:#6d28d9; }

        .cpabf-dropzone { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:20px; border:2px dashed #e2e8f0; border-radius:12px; cursor:pointer; min-height:90px; transition:all .2s; }
        .cpabf-dropzone--active:hover { border-color:#c4b5fd; background:#faf5ff; }
        .cpabf-dropzone--disabled { background:#f8fafc; opacity:.6; cursor:not-allowed; }
        .cpabf-dropzone-file { display:flex; align-items:center; gap:8px; }
        .cpabf-dropzone-filename { font-size:13px; font-weight:600; color:#0f172a; max-width:220px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
        .cpabf-dropzone-remove { display:flex; align-items:center; justify-content:center; width:22px; height:22px; border-radius:50%; background:#fee2e2; border:none; color:#dc2626; cursor:pointer; flex-shrink:0; }
        .cpabf-dropzone-placeholder { display:flex; flex-direction:column; align-items:center; }
        .cpabf-dropzone-label { font-size:13px; color:#475569; font-weight:600; }
        .cpabf-dropzone-hint { font-size:11.5px; color:#94a3b8; margin-top:2px; }

        .cpabf-loading { display:flex; align-items:center; gap:10px; padding:12px 16px; background:#f8fafc; border-radius:12px; border:1px solid #e2e8f0; }
        .cpabf-spinner { width:18px; height:18px; border:2px solid #e2e8f0; border-top-color:#7c3aed; border-radius:50%; animation:cpabfSpin .65s linear infinite; flex-shrink:0; }
        @keyframes cpabfSpin { to{transform:rotate(360deg)} }
        .cpabf-loading-txt { font-size:12.5px; color:#64748b; font-weight:500; }

        .cpabf-summary { display:flex; flex-direction:column; gap:12px; }
        .cpabf-summary-main { background:#fff; border:1.5px solid #e2e8f0; border-radius:13px; padding:16px; display:flex; justify-content:space-between; gap:16px; flex-wrap:wrap; }
        .cpabf-summary-key { font-size:11.5px; font-weight:700; color:#94a3b8; text-transform:uppercase; letter-spacing:.4px; margin-bottom:5px; }
        .cpabf-summary-val { font-size:22px; font-weight:800; color:#0f172a; line-height:1.1; }
        .cpabf-summary-currency { font-size:13px; font-weight:600; color:#64748b; }
        .cpabf-summary-fees { display:flex; flex-direction:column; gap:6px; align-self:flex-end; }
        .cpabf-fee-row { display:flex; justify-content:space-between; gap:16px; font-size:12px; color:#64748b; font-weight:500; }
        .cpabf-fee-val { font-weight:700; color:#334155; }
        .cpabf-summary-grid { display:grid; grid-template-columns:1fr 1fr; gap:10px; }
        .cpabf-summary-card { background:#fff; border:1.5px solid #e2e8f0; border-radius:11px; padding:12px 14px; }
        .cpabf-summary-card--green  { border-color:#bbf7d0; background:linear-gradient(135deg,#f0fdf4,#dcfce7); }
        .cpabf-summary-card--purple { border-color:#ddd6fe; background:linear-gradient(135deg,#faf5ff,#ede9fe); }
        .cpabf-summary-card-label { font-size:11px; font-weight:700; color:#64748b; text-transform:uppercase; letter-spacing:.4px; margin-bottom:5px; }
        .cpabf-summary-card-val { font-size:18px; font-weight:800; color:#0f172a; line-height:1.1; }
        .cpabf-summary-card-val span { font-size:12px; font-weight:600; color:#64748b; }
        .cpabf-summary-card--green  .cpabf-summary-card-val { color:#15803d; }
        .cpabf-summary-card--purple .cpabf-summary-card-val { color:#6d28d9; }

        .cpabf-error-banner { display:flex; align-items:flex-start; gap:10px; background:linear-gradient(135deg,#fff1f2,#ffe4e6); border:1.5px solid #fecaca; border-radius:11px; padding:12px 14px; font-size:12.5px; color:#b91c1c; font-weight:500; line-height:1.5; }
        .cpabf-error-banner svg { flex-shrink:0; margin-top:1px; color:#dc2626; }

        .cpabf-footer { padding:14px 26px; border-top:1.5px solid #f1f5f9; background:#fafbfc; display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:10px; flex-shrink:0; }
        .cpabf-footer-note { display:flex; align-items:center; gap:5px; font-size:12px; color:#94a3b8; font-weight:500; }
        .cpabf-footer-btns { display:flex; align-items:center; gap:8px; }
        .cpabf-btn-cancel { font-family:'Plus Jakarta Sans',sans-serif; font-size:13px; font-weight:600; color:#64748b; padding:9px 16px; border-radius:10px; border:1.5px solid #e2e8f0; background:#fff; cursor:pointer; transition:all .15s; }
        .cpabf-btn-cancel:hover { background:#f1f5f9; }
        .cpabf-btn-submit { display:inline-flex; align-items:center; gap:7px; font-family:'Plus Jakarta Sans',sans-serif; font-size:13.5px; font-weight:700; color:#fff; padding:10px 20px; border-radius:10px; border:none; background:linear-gradient(135deg,#6d28d9,#7c3aed); cursor:pointer; box-shadow:0 4px 14px rgba(124,58,237,.3); transition:transform .15s, box-shadow .18s; }
        .cpabf-btn-submit:hover:not(:disabled) { transform:translateY(-1px); box-shadow:0 8px 24px rgba(124,58,237,.38); }
        .cpabf-btn-submit:disabled { opacity:.5; cursor:not-allowed; transform:none; box-shadow:none; }
        .cpabf-btn-spinner { display:inline-block; width:15px; height:15px; border:2px solid rgba(255,255,255,.35); border-top-color:#fff; border-radius:50%; animation:cpabfSpin .65s linear infinite; }

        @media (max-width:540px) { .cpabf-panel { max-width:100%; } .cpabf-header, .cpabf-body, .cpabf-footer { padding-left:18px; padding-right:18px; } }
      `}</style>
    </>
  );
};

export default AddBatchFile;